import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  layout: {
    paddingTop: 0,
  },
}));
